module.exports = __webpack_public_path__ + "img/add_document_agent_button.5f7e28f7.svg";